import { Button, Grid, Stack } from '@mui/material';
import React, { ReactElement, useEffect, useState } from 'react';

import { PropertyCard, ExhibitionCard } from '@app/components/Product/Card';
import { theme } from '@app/theme';
import { Product } from '@app/types/catalog';

interface ProductCardListProps {
  initialVisibleItems?: number;
  isProperty?: boolean;
  products: Product[];
}

export function ProductDetailCardList({
  products,
  initialVisibleItems = 6,
  isProperty = false,
}: ProductCardListProps): ReactElement {
  const [visibleItems, setVisibleItems] = useState(initialVisibleItems);
  const loadMore = () => {
    setVisibleItems((prev) => prev + 6);
  };

  // NOTE: 表示するProductsとして展示場／分譲が切り替えられた時に表示件数をリセットする
  useEffect(() => {
    setVisibleItems(initialVisibleItems);
  }, [products, initialVisibleItems]);

  return (
    <Stack
      spacing={4}
      width={1}
      justifyContent="center"
      alignItems="center"
      mt={4}
    >
      <Grid container justifyContent="flex-start" mb={4} spacing={4}>
        {products.slice(0, visibleItems).map((data, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            key={index}
            display="flex"
            justifyContent="center"
          >
            {isProperty ? (
              <PropertyCard
                imageSrc={data.images[0]?.url || ''}
                title={data.name}
                address={
                  `${data.addressLine1}${data.addressLine2}` +
                  (data.customFields.addressLine3HiddenFlag
                    ? data.addressLine3
                    : '')
                }
                minPrice={data.customFields?.minPrice}
                maxPrice={data.customFields?.maxPrice}
                productId={data.id}
                priceRangeType={data.customFields.priceRangeType}
              />
            ) : (
              <ExhibitionCard
                productAttributes={data.attributes || []}
                imageSrc={data.images[0]?.url || ''}
                title={data.name}
                address={
                  `${data.addressLine1}${data.addressLine2}` +
                  (data.customFields.addressLine3HiddenFlag
                    ? data.addressLine3
                    : '')
                }
                productId={data.id}
              />
            )}
          </Grid>
        ))}
      </Grid>
      {visibleItems < products.length && (
        <Button
          onClick={loadMore}
          sx={{
            '&:hover': {
              backgroundColor: theme.palette.blueAccent.main,
              borderColor: theme.palette.blueAccent.main,
              color: 'white',
            },
            backgroundColor: 'white',
            border: '1px solid transparent',
            borderColor: theme.palette.blueAccent.main,
            borderRadius: 15,
            color: theme.palette.blueAccent.main,
            fontSize: 'clamp(1rem, 0.8635rem + 0.56vw, 1.25rem)',
            px: 6,
            py: 1,
            transition: 'all 0.3s ease',
            width: '100%',
          }}
        >
          もっと見る
        </Button>
      )}
    </Stack>
  );
}
